export default class GetAniosCursos {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute() {
    try {
      const result = await this.#repository.getAllAniosCursos()
      return result
    } catch (error) {
      throw error
    }
  }
}
